import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Truck } from 'lucide-react';
import { SearchBar } from '@/components/SearchBox/SearchBar';

const CarrierSummeryModal = ({ open, onClose, onSelectCarrier = () => { } }) => {
    const [selectedCarrier, setSelectedCarrier] = useState(null);

    if (!open) return null;

    const handleSelectCarrier = (carrier) => {
        setSelectedCarrier(carrier);
        onSelectCarrier(carrier);
        onClose();
    };

    return (
        <AnimatePresence>
            {open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div
                        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                        onClick={onClose}
                    />
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
                    >
                        {/* Modal Header */}
                        <div className="bg-gradient-to-r from-cyan-600 to-blue-600 px-6 py-5 flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="p-2.5 bg-white/20 rounded-lg">
                                    <Truck className="w-5 h-5 text-white" />
                                </div>
                                <h2 className="text-xl font-bold text-white">
                                    Select Carrier
                                </h2>
                            </div>
                            <button
                                onClick={onClose}
                                className="p-1 hover:bg-white/10 rounded-lg transition-colors"
                            >
                                <X className="w-5 h-5 text-white" />
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="p-6 space-y-4 bg-white dark:bg-slate-900">
                            <div>
                                <label className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-2">
                                    Carrier Name <span className="text-red-500">*</span>
                                </label>
                                <SearchBar
                                    searchAPI="v1/AutoSuggestion/GetCarrierSuggestion?Prefix="
                                    selectReacord={(d) => {
                                        setSelectedCarrier(d?.[1]);
                                        // handleInputChange({ target: { name: 'carrierName', value: d?.[1] } });
                                        // handleInputChange({ target: { name: 'carrierSno', value: d?.[0] } });
                                    }}
                                    value={selectedCarrier}
                                />
                            </div>

                            {/* Action Buttons */}
                            <div className="mt-6 pt-4 border-t border-slate-200 dark:border-slate-700">
                                <button
                                    onClick={onClose}
                                    className="w-full px-4 py-2.5 bg-gradient-to-r from-slate-200 to-slate-300 dark:from-slate-700 dark:to-slate-600 hover:from-slate-300 hover:to-slate-400 dark:hover:from-slate-600 dark:hover:to-slate-500 text-slate-900 dark:text-white rounded-lg font-medium transition-all"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default CarrierSummeryModal;